import React from 'react';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';

import { emptyAuth } from 'containers/Auth/store/actions';
import { emptyUsers } from 'containers/UsersPage/store/actions';

import { LOCALSTORAGE } from 'utils/constants';

import PageContent from 'components/PageContent';
import LoadingCircle from 'components/LoadingCircle';

class LogoutPage extends React.Component {
    componentWillMount() {
        this.props.emptyAuth();
        this.props.emptyUsers();

        localStorage.removeItem(LOCALSTORAGE.ID_TOKEN);

        this.props.changeLocation('/login');
    }

    render() {
        return (
            <PageContent>
                <LoadingCircle />
            </PageContent>
        );
    }
}

const mapStateToProps = (state) => {
    return {

    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeLocation: (path) => dispatch(routerActions.push(path)),
        emptyAuth: () => dispatch(emptyAuth()),
        emptyUsers: () => dispatch(emptyUsers())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(LogoutPage);



// WEBPACK FOOTER //
// ./src/containers/Auth/LogoutPage/index.js